module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_department03-9683db84fa17c4dd1ec40a69ccdcf652.png";